import * as actionTypes from './actionTypes'

export const projectPreviewSelectPage = (pageID) => (dispatch) => {
  dispatch({
    type: actionTypes.PROJECT_SET_PREVIEW_PAGE,
    payload: {
      pageID,
    },
  })
}
